/* eslint-disable @typescript-eslint/no-explicit-any */
import { SupplierShape } from './supplier-types';
// import csv2json from 'csvtojson';
import { handlePreprocessConversions } from '../../helpers/handlePreprocessConversions';
import { GUMAX_PRICELIST_RULESET } from './gumax/pricelist';
import { GUMAX_STOCKLIST_RULESET } from './gumax/stocklist';
import { GUMAX_CATALOG_RULESET } from './gumax/catalog';
// import { TRule } from '../typings';

export const GUMAX_SUPPLIER: SupplierShape = {
  weight: 8,
  override: true,
  ruleset: GUMAX_CATALOG_RULESET,
  pricelistRuleset: GUMAX_PRICELIST_RULESET,
  stockRuleset: GUMAX_STOCKLIST_RULESET,
  canSaveWithoutNecessaryFields: true,
  canSaveWithoutEan: false,
  stockDefaults: { model: {}, product: {} },
  pricelistDefaults: { model: {}, product: {} },
  catalogDefaults: {
    product: {
      productName2: '',
      dirtyFields: '{}',
      dataSource: 'GUMAX',
    },
    model: {
      season: '',
      usage: null,
      dataSource: 'GUMAX',
      dirtyFields: '{}',
    },
  },
  preprocessKeys: {
    netnet_eur: {
      ',': '.',
    },
  },
  hardCodes: { 1: { product: {}, model: {} } },
  async preprocessPricelist(file: any) {
    const items = file.items.item; // Extract the array of items
    const json = items.map((item: any) => {
        const newItem: any = {};
        for (const key in item) {
            if (Object.prototype.hasOwnProperty.call(item, key)) {
                newItem[key] = item[key];
            }
        }
        return newItem;
    });

    // dodat DOT rule
    return handlePreprocessConversions(json, this.preprocessKeys);
  },
  async preprocessStockList(file: any) {

    const items = file.items.item; // Extract the array of items
    const json = items.map((item: any) => {
        const newItem: any = {};
        for (const key in item) {
            if (Object.prototype.hasOwnProperty.call(item, key)) {
                newItem[key] = item[key];
            }
        }
        return newItem;
    });

    return handlePreprocessConversions(json, this.preprocessKeys);
  },
  async preprocessCatalog(file: any) {

    const items = file.items.item; // Extract the array of items
    const json = items.map((item: any) => {
        const newItem: any = {};
        for (const key in item) {
            if (Object.prototype.hasOwnProperty.call(item, key)) {
                newItem[key] = item[key];
            }
        }
        return newItem;
    });

    return handlePreprocessConversions(json, this.preprocessKeys);
  }

};
